export default __webpack_public_path__ + "static/media/andrei.d822e60d.png";